import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'
import store from '@/store'; // 如果你使用 Vuex 来管理状态
Vue.use(Router)

const router = new Router({
  routes: [
    //登录
    {
      path: '/login',
      component: Layout,
      children: [
        {
          path: '',
          name: 'login',
          component: () => import("@/views/login/login"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //首页
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'index',
          component: () => import("@/views/index/index"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //注册
    {
      path: '/register',
      component: Layout,
      children: [
        {
          path: '',
          name: 'register',
          component: () => import("@/views/register/register"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //忘记密码
    {
      path: '/forget',
      component: Layout,
      children: [
        {
          path: '',
          name: 'forget',
          component: () => import("@/views/forget/forget"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //验证码
    {
      path: '/captcha',
      component: Layout,
      children: [
        {
          path: '',
          name: 'captcha',
          component: () => import("@/views/forget/captcha"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //成为协调员
    {
      path: '/becomeCoordinator',
      component: Layout,
      children: [
        {
          path: '',
          name: 'becomeCoordinator',
          component: () => import("@/views/register/becomeCoordinator"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //成为需求方
    {
      path: '/becomeDemandSide',
      component: Layout,
      children: [
        {
          path: '',
          name: 'becomeDemandSide',
          component: () => import("@/views/register/becomeDemandSide"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //成为供应商
    {
      path: '/becomeSupply',
      component: Layout,
      children: [
        {
          path: '',
          name: 'becomeSupply',
          component: () => import("@/views/register/becomeSupply"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //====================================需求方界面================================
    //商品详情
    {
      path: '/demandSide/merchandiseDetail',
      component: Layout,
      children: [
        {
          path: '',
          name: 'merchandiseDetail',
          component: () => import("@/views/demandSide/merchandise/components/merchandiseDetail"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //商品卡片
    {
      path: '/demandSide/merchandise',
      component: Layout,
      children: [
        {
          path: '',
          name: 'merchandise',
          component: () => import("@/views/demandSide/merchandise/merchandiseCard"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //结账
    {
      path: '/demandSide/checkoutMer',
      component: Layout,
      children: [
        {
          path: '',
          name: 'checkoutMer',
          component: () => import("@/views/demandSide/merchandise/checkoutMer/checkoutMer"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    // 商品交易流程，协调费，运费
    {
      path: '/demandSide/checkoutMerOther',
      component: Layout,
      children: [
        {
          path: '',
          name: 'checkoutMerOther',
          component: () => import("@/views/demandSide/merchandise/checkoutMer/checkoutMerOther"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //供应商店铺主页
    {
      path: '/demandSide/supplyStore',
      component: Layout,
      children: [
        {
          path: '',
          name: 'supplyStore',
          component: () => import("@/views/demandSide/supply/supplyStore"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //====================================我的账户================================
    //我的购物
    {
      path: '/myAccount/myShopping',
      component: Layout,
      children: [
        {
          path: '',
          name: 'myShopping',
          component: () => import("@/views/demandSide/myAccount/myShopping/myShopping"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的认证
    {
      path: '/myAccount/myAuth',
      component: Layout,
      children: [
        {
          path: '',
          name: 'myAuth',
          component: () => import("@/views/demandSide/myAccount/myAuth/myAuth"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //个人资料
    {
      path: '/myAccount/myPerinfo',
      component: Layout,
      children: [
        {
          path: '',
          name: 'myPerinfo',
          component: () => import("@/views/demandSide/myAccount/myPerinfo/myPerinfo"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //订单追踪
    {
      path: '/myAccount/orderTracking',
      component: Layout,
      children: [
        {
          path: '',
          name: 'orderTracking',
          component: () => import("@/views/demandSide/myAccount/myShopping/orderTracking"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的需求
    {
      path: '/myAccount/myNeeds',
      component: Layout,
      children: [
        {
          path: '',
          name: 'myNeeds',
          component: () => import("@/views/demandSide/myAccount/myNeeds/myNeeds"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //发布需求
    {
      path: '/myAccount/myNeeds/publishNeeds',
      component: Layout,
      children: [
        {
          path: '',
          name: 'publishNeeds',
          component: () => import("@/views/demandSide/myAccount/myNeeds/components/publishNeeds"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //====================================供应方================================
    //我的店铺
    {
      path: '/supplySide/myAccount/myShop',
      component: Layout,
      children: [
        {
          path: '',
          name: 'myShop',
          component: () => import("@/views/supplySide/myAccount/myShop/myShop"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的店铺--店铺信息修改
    {
      path: '/supplySide/myShop/storeInfoMod',
      component: Layout,
      children: [
        {
          path: '',
          name: 'storeInfoMod',
          component: () => import("@/views/supplySide/myAccount/myShop/storeInfoMod"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //案例详情
    {
      path: '/demandSide/caseDetail',
      component: Layout,
      children: [
        {
          path: '',
          name: 'caseDetail',
          component: () => import("@/views/demandSide/case/components/caseDetail"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的店铺--店铺内商品分类
    {
      path: '/supplySide/myShop/storeCategories',
      component: Layout,
      children: [
        {
          path: '',
          name: 'storeCategories',
          component: () => import("@/views/supplySide/myAccount/myShop/storeCategories"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的店铺--店铺内案例分类
    {
      path: '/supplySide/myShop/caseCategories',
      component: Layout,
      children: [
        {
          path: '',
          name: 'caseCategories',
          component: () => import("@/views/supplySide/myAccount/myShop/caseCategories"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的店铺--店铺内案例分类-下级分类
    {
      path: '/supplySide/myShop/caseCategSubClass',
      component: Layout,
      children: [
        {
          path: '',
          name: 'caseCategSubClass',
          component: () => import("@/views/supplySide/myAccount/myShop/caseCategSubClass"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的店铺--店铺内商品分类-下级分类
    {
      path: '/supplySide/myShop/storeCategSubClass',
      component: Layout,
      children: [
        {
          path: '',
          name: 'storeCategSubClass',
          component: () => import("@/views/supplySide/myAccount/myShop/storeCategSubClass"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的店铺-收款方式绑定
    {
      path: '/supplySide/myShop/payoutMethods',
      component: Layout,
      children: [
        {
          path: '',
          name: 'payoutMethods',
          component: () => import("@/views/supplySide/myAccount/myShop/payoutMethods"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    {
      path: '/supplySide/demandCardDetail',
      component: Layout,
      children: [
        {
          path: '',
          name: 'demandCardDetail',
          component: () => import("@/views/supplySide/demand/components/demandCardDetail"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户--我的投标
    {
      path: '/supplySide/myAccount/myBidding',
      component: Layout,
      children: [
        {
          path: '',
          name: 'myBidding',
          component: () => import("@/views/supplySide/myAccount/myBidding/myBidding"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户--中标订单
    {
      path: '/supplySide/myAccount/winningOrder',
      component: Layout,
      children: [
        {
          path: '',
          name: 'winningOrder',
          component: () => import("@/views/supplySide/myAccount/winningOrder/winningOrder"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户-我的店铺-商品管理
    {
      path: '/supplySide/myShop/merchandiseManage',
      component: Layout,
      children: [
        {
          path: '',
          name: 'merchandiseManage',
          component: () => import("@/views/supplySide/myAccount/myShop/merchandiseManage"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户-我的店铺-发布商品
    {
      path: '/supplySide/myShop/publishMer',
      component: Layout,
      children: [
        {
          path: '',
          name: 'publishMer',
          component: () => import("@/views/supplySide/myAccount/myShop/publishMer"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户-订单管理
    {
      path: '/supplySide/myAccount/orderManagement',
      component: Layout,
      children: [
        {
          path: '',
          name: 'orderManagement',
          component: () => import("@/views/supplySide/myAccount/orderManagement/orderManagement"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户-案例管理
    {
      path: '/supplySide/myAccount/caseManagement',
      component: Layout,
      children: [
        {
          path: '',
          name: 'caseManagement',
          component: () => import("@/views/supplySide/myAccount/caseManagement/caseManagement"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //我的账户-发布案例
    {
      path: '/supplySide/myAccount/publishCase',
      component: Layout,
      children: [
        {
          path: '',
          name: 'publishCase',
          component: () => import("@/views/supplySide/myAccount/caseManagement/publishCase"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //====================================协调方================================
    //   货品协调订单
    {
      path: '/coordinatorSide/ordersGoods',
      component: Layout,
      children: [
        {
          path: '',
          name: 'ordersGoods',
          component: () => import("@/views/coordinatorSide/myAccount/ordersGoods"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //   我的账户-账户设置
    {
      path: '/coordinatorSide/myAccount/accountSettings',
      component: Layout,
      children: [
        {
          path: '',
          name: 'accountSettings',
          component: () => import("@/views/coordinatorSide/myAccount/accountSettings"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //   我的账户-需求订单
    {
      path: '/coordinatorSide/myAccount/demandOrder',
      component: Layout,
      children: [
        {
          path: '',
          name: 'demandOrder',
          component: () => import("@/views/coordinatorSide/myAccount/demandOrder"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    // ==================================公共页面==============================
    //   合同
    {
      path: '/contractFile',
      component: Layout,
      children: [
        {
          path: '',
          name: 'contractFile',
          component: () => import("@/components/contractFile.vue"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //   结账
    {
      path: '/checkoutDemand',
      component: Layout,
      children: [
        {
          path: '',
          name: 'checkoutDemand',
          component: () => import("@/components/checkoutDemand.vue"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //   消息
    {
      path: '/myAccount/messages',
      component: Layout,
      children: [
        {
          path: '',
          name: 'messages',
          component: () => import("@/views/layout/components/messages.vue"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
    //   超管登录
    {
      path: '/supertubeLogin',
      component: Layout,
      children: [
        {
          path: '',
          name: 'supertubeLogin',
          component: () => import("@/views/login/supertubeLogin.vue"),
          meta:{
            noLogin:false
          }
        }
      ]
    },
  ]
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.name !== from.name && to.name != 'login' && to.name != 'index' && store.state.isLoggedIn==1 && store.state.isRole !=0 && store.state.isRole !=4) {
    store.dispatch('attachmentDownload');
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js